import styled from 'styled-components';

const MyDiv = styled.div`
.declaration{
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 4px 6px;
    gap: 7px;
    width: 145px;
    height: 36px;
    left: 571px;
    top: 140px;
    background: rgba(0, 128, 0, 0.06);
    border: 1px solid #008000;
    border-radius: 60px;
}

.regime {
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 4px 5px 4px 11px;
    width: 235px;
    height: 36px;
    left: 727px;
    top: 137px;
    background: rgba(221, 238, 204, 0.06);
    border: 1px solid #800080;
    border-radius: 60px;
}

.new {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 5px 10px;
    gap: 10px;
    width: 130px;
    height: 31px;
    background: #800080;
    border-radius: 64px;
    color:white;
}
  .tag {
    background: #E6F4EA;
    color: #2F855A;
    font-size: 12px;
    font-weight: 500;
    padding: 4px 8px;
    border-radius: 8px;
  }

  .tag-blue {
    background: #EDF2FF;
    color: #3B82F6;
  }
  .main{
    filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.15));
    background-color: #F9F9F9;
    border-radius:12px;
}
.col{
    color:rgba(0, 0, 0, 1)
}

.box{
filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.15));
}

/* ... (keep all your existing styles) */

  table {
    width: 100%;
    border-collapse: collapse;
  }

  th, td {
    padding: 12px 16px;
    text-align: center;
  }

  th {
    background-color: #F9F9F9;
    font-weight: 500;
  }

  tr:hover {
    background-color: #F9F9F9;
  }

  .section-card {
    margin-top: 16px;
    overflow-x: auto;
  }
    

.section-card {
    background: #FFFFFF;
    border-radius: 12px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
    filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.15));
  }

.reject {
  color:#D92F34;
  background-color: #FF00001A;
  &:hover{
  color:#D92F34;
  background-color: #FF00001A;
  }
}
.accept{
  color:white;
  background-color: #00B103;
  &:hover{
  color:white;
  background-color: #00B103;
  }
}
 
`;

export default MyDiv;
